<!-- Universities List -->
@if ((!store.isLoading() || store.isLoadingPagination()) && store.universities()) {
	<div class="grid gap-10 sm:gap-8">
		@for (university of store.universities()?.data; track university.id) {
			<uc-university-card
				[uniName]="university.name"
				[uniSlug]="university.slug"
				[uniId]="university.id"
				[uniLogo]="university.logo"
				[uniCover]="getDetailByProduct(university, 'cover_image', null)"
				[clientFeatures]="university.paid_features"
				[saved]="university.saved"
				[recommended]="university.stats.recommended_percentage"
				[searchTerm]="searchTerm()"
				source="universities"
				[displaySeeCoursesBtn]="true"
				[product]="product()"
				[privacyPolicyUrl]="university.privacy_policy_url"
				[externalUrl]="
					getDetailByProduct(university, 'external_url', 'undergraduate')
				"
				[externalUgProspectusUrl]="
					getDetailByProduct(
						university,
						'external_prospectus_url',
						'undergraduate'
					)
				"
				[externalPgProspectusUrl]="
					getDetailByProduct(
						university,
						'external_prospectus_url',
						'postgraduate'
					)
				"
				[ugSearchOrderPosition]="university.order"
				[region]="notApplicable"
				[degreeLevel]="notApplicable"
			/>
		}
		@if (store.universities()?.total === 0) {
			<uc-no-result>
				<p class="text-gray-500">Try entering "Oxford" or "Brunel"</p>
			</uc-no-result>
		}
		@if (store.universities()?.has_more_pages) {
			<uc-university-pagination />
		}
	</div>
} @else if (store.isLoading() && !store.isLoadingPagination()) {
	<uc-universities-skeleton [filter]="false" />
}
